<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='文章列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col v-if="rights.canAdd==1" :span="2">
          <el-button type="primary" @click="showAddDialog">添加文章</el-button>
        </el-col>
        <el-col :span="3">
          <el-select v-model="param.category_id" placeholder="请选择分类" filterable>
            <el-option label="请选择分类" value="0"></el-option>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col v-if="rights.canPublish==1" :span="3">
          <el-select v-model="param.post_status" placeholder="是否推荐" filterable>
            <el-option label="全部" value="0"></el-option>
            <el-option label="不推荐" value="1"></el-option>
            <el-option label="推荐" value="2"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3" v-if="roleId==1">
          <el-select v-model="param.author_id" placeholder="请选择作者" filterable>
            <el-option label="请选择作者" :value="0"></el-option>
            <el-option v-for="item in authorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="请输入文章标题" v-model="param.keyword" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col v-if="rights.canDownload==1" :span="2">
          <a href="/proxy/admin/download/article_list"><el-button type="primary">导出列表</el-button></a>
        </el-col>
        <el-col :span="2">
          <a :href="authorPageurl" target="_blank"><el-button type="primary">我的主页</el-button></a>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="articleList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="title" label="标题" align="center">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="pic" label="封面" align="center">
        <template slot-scope="scope">
          <el-image v-if="scope.row.pic!=''" :src="scope.row.pic+'?imageView2/0/w/50'" class="list_img"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="二维码" align="center" width="170px">
        <template slot-scope="scope">
          <el-image :src="getQRcode(scope.row.url)" style="width:80px;"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="category_name" label="分类" align="center"></el-table-column>
      <el-table-column prop="author_name" label="作者" align="center"></el-table-column>
      <el-table-column prop="post_hits" label="点击量" align="center"></el-table-column>
      <el-table-column v-if="rights.canPublish==1" label="是否推荐" align="center">
        <template slot-scope="scope">
          <el-switch :value="scope.row.post_status==1"></el-switch>
          <div v-if="scope.row.post_status==1">{{scope.row.published_time | dateTimeFormat}}</div>
          <div v-if="scope.row.post_status==1">
            <span v-if="scope.row.published_end_time===0">一直推荐</span>
            <span v-else-if="scope.row.published_end_time<=nowTime" style="color: #ff0000;">{{scope.row.published_end_time | dateTimeFormat}}</span>
            <span v-else>{{scope.row.published_end_time | dateTimeFormat}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center">
       <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column v-if="rights.canUpdate==1 || rights.canDelete==1 || rights.canPublish==1" label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button v-if="rights.canUpdate==1" type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button v-if="rights.canDelete==1" type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          <el-button v-if="scope.row.post_status==0 && rights.canPublish==1" type="success" icon="el-icon-finished" size="mini" @click="showPublishDialog(scope.row.id)">推荐</el-button>
          <el-tooltip v-if="scope.row.post_status==1 && rights.canPublish==1" effect="dark" content="取消推荐" placement="top" :enterable="false">
            <el-button  type="warning" icon="el-icon-finished" size="mini" @click="unPublish(scope.row.id)">取消</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <article-add :visible="addDialogAvaible"
      :id="currentId"
      :categoryList="categoryList"
      :authorList="authorList"
      :canEditAuthor="rights.canEditAuthor==1"
      @add="add"
      @update="update"
      @close="closeAddDialog">
    </article-add>
    <article-publish :visible="publishAvaible"
      :id="publishId"
      @publish="publish"
      @closePublish="closePublishDialog">
    </article-publish>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import ArticleAdd from './ArticleAdd.vue'
import ArticlePublish from './AriclePublish.vue'
import QRCode from 'qrcode'
export default {
  name: 'article_list',
  components: {
    'bread-crumb': BreadCrumb,
    'article-add': ArticleAdd,
    'article-publish': ArticlePublish
  },
  data () {
    return {
      adminId: 0,
      roleId: 0,
      articleList: [],
      categoryList: [],
      authorList: [],
      rights: {
        canAdd: 0,
        canUpdate: 0,
        canDelete: 0,
        canPublish: 0,
        canDownload: 0,
        canEditAuthor: 0
      },
      currentId: 0,
      publishId: 0,
      total: 0,
      pageTotal: 1,
      authorPageurl: '',
      nowTime: 0,
      param: {
        is_back: 1,
        category_id: '',
        author_id: '',
        post_status: '',
        keywords: '',
        page: 1,
        count: 10
      },
      addDialogAvaible: false,
      publishAvaible: false
    }
  },
  created () {
    this.getList()
    this.getCategoryList()
    this.getAuthorList()
    this.getAdminInfo()
    const rights = window.sessionStorage.getItem('rights')
    if (rights.indexOf('22') !== -1) {
      this.rights.canAdd = 1
    }
    if (rights.indexOf('23') !== -1) {
      this.rights.canUpdate = 1
    }
    if (rights.indexOf('24') !== -1) {
      this.rights.canDelete = 1
    }
    if (rights.indexOf('21') !== -1) {
      this.rights.canPublish = 1
    }
    if (rights.indexOf('37') !== -1) {
      this.rights.canDownload = 1
    }
    if (rights.indexOf('63') !== -1) {
      this.rights.canEditAuthor = 1
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/article/list', this.param)
      if (res.code === 0) {
        this.articleList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
        this.authorPageurl = res.data.author_page_url
        this.nowTime = res.data.now_time
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCategoryList () {
      const res = await this.$http.get('/admin/article/category/list')
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAuthorList () {
      const res = await this.$http.get('/admin/select_list')
      if (res.code === 0) {
        this.authorList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAdminInfo () {
      const res = await this.$http.get('/admin/info')
      if (res.code !== 0) {
        this.$message.error(res.msg)
      }
      this.adminId = res.data.id
      this.roleId = res.data.role_id
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    showPublishDialog (id) {
      this.publishId = id
      this.publishAvaible = true
    },
    closePublishDialog () {
      this.publishAvaible = false
      this.publishId = 0
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/article/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async add (data) {
      const res = await this.$http.post('/admin/article/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/article/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async publish (id, startTime, endTime) {
      const data = {
        publish_start_time: startTime,
        publish_end_time: endTime
      }
      const res = await this.$http.post('/admin/article/publish/' + id, data)
      if (res.code === 0) {
        this.$message.success('推荐成功')
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
      this.closePublishDialog()
    },
    async unPublish (id) {
      this.$confirm('真的要取消推荐这篇文章?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/article/un_publish/' + id)
        if (res.code === 0) {
          this.$message.success('取消成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    getQRcode (text) {
      const opts = {
        width: 270,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      }
      let result = ''
      QRCode.toDataURL(text, opts, (err, url) => {
        if (err) throw err
        result = url
      })
      return result
    }
  }
}
</script>

<style scoped>
</style>
